__turbopack_context__.v({
  "marquee": "umC5fq_marquee",
  "overlay": "umC5fq_overlay",
  "root": "umC5fq_root",
  "scroll": "umC5fq_scroll",
});
